import React, { memo } from 'react';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  text?: React.ReactNode;
}

const CreatorTag: React.FC<Props> = ({
  text = 'Creator',
  className = '',
  ...props
}) => {
  return (
    <span className={`creator-tag ${className}`} {...props}>
      {text}
    </span>
  );
};

export default memo(CreatorTag);
